import { BOOLEAN_FIELDS, HIDDEN_FIELD_PATHS } from './constants.js';

export const deepClone = (value) =>
  value !== null && typeof value === 'object'
    ? JSON.parse(JSON.stringify(value))
    : value;

export const getByPath = (obj, path) =>
  path.reduce((acc, segment) => (acc == null ? acc : acc[segment]), obj);

export const setByPath = (obj, path, value) => {
  if (path.length === 0) {
    return value;
  }

  const [head, ...tail] = path;

  if (Array.isArray(obj)) {
    const copy = [...obj];
    copy[head] = setByPath(copy[head], tail, value);
    return copy;
  }

  return {
    ...obj,
    [head]: setByPath(obj?.[head], tail, value),
  };
};

export const normalizePath = (path) =>
  path
    .map((segment) => (typeof segment === 'number' ? '*' : segment))
    .join('.');

export const isHiddenPath = (path) => HIDDEN_FIELD_PATHS.has(normalizePath(path));

export const isBooleanPath = (path) => BOOLEAN_FIELDS.has(normalizePath(path));

export const applyApplicationValue = (baseValue, withPrefixC) =>
  withPrefixC ? `C${baseValue}` : baseValue;